/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/4/20
 * Time: 5:02 PM
 */

export const IS_SPINNER = 'IS_SPINNER';
